export default __webpack_public_path__ + "static/media/add.5f886273.svg";